export default (objects: string): string => `
-- THESE ARE ALL OF THE NODES/OBJECTS (emails, webhooks, wait timers, tags, date objects, etc.) IN THE CURRENT WORKFLOW VIEW --
${objects}
`;